import script from "./VHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./VHeader.vue?vue&type=script&lang=ts&setup=true"

import "./VHeader.vue?vue&type=style&index=0&id=00ad2113&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00ad2113"]])

export default __exports__